<template>
  <div>
    <SMultiSelect
      ref="multi"
      v-model="values"
      :btnLabel="btnLabel"
      search
      :selectOptions="multiselectData"
      :addItem="addItem"
      :addNewInfo="addNewInfo"
      @add-new="addNewClick"
      :label="label"
      :sortableList="sortList"
      :options="opts"
      :error="error"
      :disabled="disabled" 
      :readonly="readonly"
      :noResultText="noResultText"
      :position="position"
    >
      <template v-slot:option="{ option }">
        <div class="complex-parent-div">
          <input
            v-if="checkbox"
            type="checkbox"
            class="checkbox-custom"
            :checked="option.selected"
          />
          <SAvatar
            v-if="avatar"
            :fullname="option[optionLabel].toString()"
            :size="40"
            :color="'#d8d8d8'"
          />

          <label class="checkbox-custom-label">
            <div class="complex-option-div">
              <span :style="getOptionsStyle">{{ option[optionLabel] }}</span>
              <span v-if="optionDescription" class="option-description">{{
                option[optionDescription]
              }}</span>
            </div>
          </label>
        </div>
      </template>
    </SMultiSelect>
  </div>
</template>

<script>
import SMultiSelect from "../components/SMultiSelect.vue";
import SAvatar from "../components/SAvatar.vue";

export default {
  name: "MultiSelect",

  data() {
    return {
      btnLabel: (values) => this.getName(),
      values: this.value,
      multiselectData: [],
      descFlag: false,
      opts: {},
    };
  },

  computed: {
    getOptionsStyle() {
      if (this.descFlag) {
        return {
          position: "relative",
          top: "5px",
        };
      } else {
        return "";
      }
    },
  },

  props: {
    checkbox: {
      type: Boolean,
    },
    avatar: {
      type: Boolean,
    },
    data: {
      type: Array,
    },
     readonly: {
      type: Boolean,
      default:false
    },
    label: {
      type: String,
    },
    optionLabel: {
      type: String,
    },
    optionDescription: {
      type: String,
    },
    addItem: {
      Type: Boolean,
      default: false,
    },
    addNewInfo: {
      type: [Object, Array, Function],
    },
    sortList: {
      type: Boolean,
    },
    groups: {
      type: Boolean,
      default: false,
    },
    value: {},
    error: {
      type: String,
    },
     disabled: {
      type: Boolean,
      default: false,
    },
    noResultText: {
      type: String,
      default: null
    },
    position: {
      type: String,
      default: 'bottom-left',
    },
  },

  methods: {
    getName() {
      let options = [];
      if (this.values) {
        for (let i = 0; i < this.values.length; i++) {
          if (this.values[i][this.optionLabel]) {
            options.push(" " + this.values[i][this.optionLabel]);
          }
        }
      }

      if (options.length == 0) {
        return "";
      } else {
        return options.toString();
      }
    },
    addNewClick($event) {
      this.$emit("add-new", $event);
    },
  },

  mounted() {
    // setting already selected values in multi-select
    this.values = this.value;

    // setting group settings in options prop
    this.opts = {
      multi: true,
      groups: this.groups,
    };

    // setting options list
    this.multiselectData = this.data;

    if (!this.optionDescription || this.optionDescription == null) {
      this.descFlag = true;
    }
  },

  watch: {
    values: function (nv, ov) {
      if (nv != ov) {
        this.$emit("selected-values", this.values);
        this.$emit("input", this.values);
      }
    },
    data: function (nv, ov) {
      if (nv != ov) {
        this.data = nv;
        this.multiselectData = this.data;
      }
    },
    groups: function () {
      this.opts = {
        multi: true,
        groups: this.groups,
      };
    },
  },

  components: {
    SMultiSelect,
    SAvatar,
  },
};
</script>

<style scoped>
</style>